import {
  ExamTitle,
  HandWriting,
  HandWritingBox,
  Line,
  Objective,
  ObjectiveBox,
  ObjectiveTitle,
  TitleBox,
} from "./AllalinhornStyles";

export const AllalinhornExamHeader = ({
  title,
  objectiveIndex,
  objective,
  zoomFactor,
  groupColorDark
}: {
  title: string;
  objectiveIndex: number;
  objective: string;
  zoomFactor: number;
  groupColorDark: string;
}) => {
  return (
    <>
      <TitleBox zoomfactor={zoomFactor}>
        <ExamTitle zoomfactor={zoomFactor}>{title}</ExamTitle>
        <HandWritingBox zoomfactor={zoomFactor}>
          <HandWriting zoomfactor={zoomFactor}>Name:</HandWriting>
          <Line />
        </HandWritingBox>
      </TitleBox>
      <ObjectiveBox zoomfactor={zoomFactor} selectedColor={groupColorDark}>
        <ObjectiveTitle zoomfactor={zoomFactor}>Kompetenz {objectiveIndex}</ObjectiveTitle>
        <Objective zoomfactor={zoomFactor}>{objective}</Objective>
      </ObjectiveBox>
    </>
  );
};

export default AllalinhornExamHeader;
